export type Attributes = { [key: string]: any };

declare const __zone_symbol__requestAnimationFrame: typeof window.requestAnimationFrame;

/**
 * Patched version of requestAnimationFrame that avoids ngzone
 * Use only when you know ngzone should not run
 */
 export const raf = (h: FrameRequestCallback) => {
    if (typeof __zone_symbol__requestAnimationFrame === 'function') {
      return __zone_symbol__requestAnimationFrame(h);
    }
    if (typeof requestAnimationFrame === 'function') {
      return requestAnimationFrame(h);
    }
    return setTimeout(h);
};

/**
 * Waits for a component to be ready for
 * both custom element and non-custom element builds.
 * If non-custom element build, el.componentOnReady
 * will be used.
 * For custom element builds, we wait a frame
 * so that the inner contents of the component
 * have a chance to render.
 *
 * Use this utility rather than calling
 * el.componentOnReady yourself.
 */
export const componentOnReady = (el: any, callback: any) => {
    if (el.componentOnReady) {
        // eslint-disable-next-line custom-rules/no-component-on-ready-method
        el.componentOnReady().then((resolvedEl: any) => callback(resolvedEl));
    } else {
        raf(() => callback(el));
    }
};

export const addEventListener = (el: any, eventName: string, callback: any, opts?: any) => {
    if (typeof (window as any) !== 'undefined') {
        const win = window as any;
        const config = win?.Ionic?.config;
        if (config) {
        const ael = config.get('_ael');
        if (ael) {
            return ael(el, eventName, callback, opts);
        } else if (config._ael) {
            return config._ael(el, eventName, callback, opts);
        }
        }
    }

    return el.addEventListener(eventName, callback, opts);
};

export const removeEventListener = (el: any, eventName: string, callback: any, opts?: any) => {
    if (typeof (window as any) !== 'undefined') {
        const win = window as any;
        const config = win?.Ionic?.config;
        if (config) {
        const rel = config.get('_rel');
        if (rel) {
            return rel(el, eventName, callback, opts);
        } else if (config._rel) {
            return config._rel(el, eventName, callback, opts);
        }
        }
    }

    return el.removeEventListener(eventName, callback, opts);
};